import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/customers'

const findOne = async (customerIdOrDocument, queryParams = '', organization) => {
  try {
    const response = await AxiosClient.get(
      `${resource}/${customerIdOrDocument}?${queryParams}`, { headers: { organization } }
    )
    return response
  } catch (error) {
    return error
  }
}

const findByPathAndDocument = async (document, organization, hash = '') => {
  const result = await AxiosClient.get(`${resource}/cod/${document}?hash=${hash}`, { headers: { organization } })

  return result
}

const create = async (data, organization) => {
  const response = await AxiosClient.post(`${resource}/cod`, data, { headers: { organization } })

  return response
}

export {
  findOne,
  findByPathAndDocument,
  create
}
